export enum RentalApplicationSteps {
  WELCOME = 'welcome',
  APPLICANT_INFORMATION = 'applicantInformation',
  POTENTIAL_UNITS = 'potentialUnits',
  RENTAL_HISTORY = 'rentalHistory',
  WORK_HISTORY = 'workHistory',
  PETS_AND_CARS = 'petsAndCars',
  Pets = 'pets',
  Cars = 'cars',
  QUESTIONS = 'questions',
  TERMS_AND_CONDITIONS = 'termsAndConditions',
  PAYMENT = 'payment',
  TRANS_UNION_SCREENING = 'transUnionScreening',
  TRANS_UNION_QUESTIONS = 'transUnionQuestions',
  APPLICATION_SUBMITTED = 'applicationSubmitted',
  MANUAL_VERIFICATION = 'manualVerification',
}
